/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card, message } from "antd";
import { Collapse, Form, Flex, Row, Col, Space } from "antd";
import { Input, Button, Table, Typography, Select, Badge } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdGroupAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useAccessPageState from '../../../hooks/useAccessPageState';

// import dayjs from 'dayjs';
import SupplierService from "../../../service/ERP/Supplier.service";
import "./supplier.css";

const supplierservice = SupplierService();

/* ค่าเริ่มต้นแสดงเฉพาะที่เปิดใช้งาน — ที่ปิดแล้วต้องเลือกเองถึงจะเห็น */
const STATUS_OPTIONS = [
  {
    value: "เปิดการใช้งาน",
    label: <Badge status="success" text="เปิดการใช้งาน" />,
  },
  {
    value: "ปิดการใช้งาน",
    label: <Badge status="error" text="ปิดการใช้งาน" />,
  },
  {
    value: "ทั้งหมด",
    label: <Badge status="default" text="ทั้งหมด" />,
  },
];
const DEFAULT_STATUS = "เปิดการใช้งาน";

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const SuppliersAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
      const runSearch = (v) => {
        saveState(v, paginationOverride ?? tablePagination);
        const data = { ...v };
        supplierservice
          .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
          .then((res) => {
            const { data } = res.data;
  
            setAccessData(data);
          })
          .catch((err) => {
            console.log(err);
            message.error("Request error!");
          });
      };

      if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
        runSearch(forcedValues);
        return;
      }

      form.validateFields().then((v) => {
        runSearch(v);
      });
    };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", DEFAULT_STATUS);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: DEFAULT_STATUS }, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "สร้าง Supplier",
          action: "create",
        },
      },
    });
  };

  const handleEdit = (data) => {
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "แก้ไข Supplier",
          action: "edit",
          code: data?.supcode,
        },
      },
    });
  };

  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View Supplier",
          action: "view",
          code: data?.supcode,
        },
      },
    });
  };

  const getData = (data) => {
      supplierservice
        .search(data)
        .then((res) => {
          const { data } = res.data;
  
          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

  useEffect(() => {
      const restored = restoreState();

      /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดการใช้งาน" */
      const values = restored?.searchValues ?? {};
      if (!values.active_status) values.active_status = DEFAULT_STATUS;
      form.setFieldsValue(values);

      handleSearch(values, restored?.tablePagination);
    }, []);

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                onValuesChange={() => {
                  handleSearch();
                }}
              >
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="รหัสผู้ขาย." name="supcode">
                      <Input placeholder="Enter Supplier Code." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ชื่อผู้ขาย." name="supname">
                      <Input placeholder="Enter Supplier Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ประเทศ." name="country">
                      <Input placeholder="Enter Countires." />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    {/* ประเภทผู้ขาย — ตรงกับตัวเลือกในหน้าเพิ่ม/แก้ไขผู้ขาย */}
                    <Form.Item label="ประเภทผู้ขาย" name="suptype">
                      <Select
                        allowClear
                        style={{ height: 40 }}
                        placeholder="เลือกประเภทผู้ขาย"
                        options={[
                          { value: "IG", label: "Ingredients" },
                          { value: "RM", label: "Raw Material" },
                          { value: "PK", label: "Packaging" },
                          { value: "API", label: "Oversea" },
                          { value: "GR", label: "General" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="สถานะการใช้งาน" name="active_status">
                      <Select
                        style={{ height: 40 }}
                        options={STATUS_OPTIONS}
                        placeholder="เลือกสถานะ"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        Search
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        Clear
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
      // bordered={false}
    />
  );
  const column = accessColumn({ handleEdit, handleView });

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
          List of Supplier
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdGroupAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            สร้างผู้ขาย
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="supplier-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="supcode"
                columns={column}
                dataSource={accessData}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default SuppliersAccess;
